var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19032 12.875C8.68011 12.875 8.25 12.6989 7.9 12.3466C7.55 11.9943 7.375 11.563 7.375 11.0528C7.375 10.5426 7.55114 10.1125 7.90343 9.7625C8.25572 9.4125 8.68697 9.2375 9.19718 9.2375C9.70739 9.2375 10.1375 9.41364 10.4875 9.76593C10.8375 10.1182 11.0125 10.5495 11.0125 11.0597C11.0125 11.5699 10.8364 12 10.4841 12.35C10.1318 12.7 9.70053 12.875 9.19032 12.875ZM1.375 15.5C1.075 15.5 0.8125 15.3875 0.5875 15.1625C0.3625 14.9375 0.25 14.675 0.25 14.375V2.75C0.25 2.45 0.3625 2.1875 0.5875 1.9625C0.8125 1.7375 1.075 1.625 1.375 1.625H2.59375V0.5H3.8125V1.625H10.1875V0.5H11.4062V1.625H12.625C12.925 1.625 13.1875 1.7375 13.4125 1.9625C13.6375 2.1875 13.75 2.45 13.75 2.75V14.375C13.75 14.675 13.6375 14.9375 13.4125 15.1625C13.1875 15.3875 12.925 15.5 12.625 15.5H1.375ZM1.375 14.375H12.625V6.3125H1.375V14.375Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.53033ff889782cf4c619f568efd2a483.svg";
export { ForwardRef as ReactComponent };